var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMfaAppSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 135,
    viewBox: "0 0 281 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7109 122.419H280.967L226.172 9.91565H80.9666L90.0777 75.1772L47.7109 122.419Z",
    fill: "#CAFAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.786 36.8987C165.786 75.9867 109.077 122.114 78.6886 122.114C75.4902 122.114 50.7596 122.788 47.7107 122.114L0.78833 9.91565H165.786C166.989 15.7347 165.786 30.5924 165.786 36.8987Z",
    fill: "#78EDF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.052 63.0772L280.346 120.719L279.706 122.223L121.345 123.038L121.339 121.078L278.325 120.27L250.765 64.1244L252.052 63.0772Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2169 11.7701H0.78833V9.91565H72.2169V11.7701Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.896 131.819H103.104C102.511 131.819 101.942 131.584 101.523 131.165C101.104 130.745 100.868 130.176 100.868 129.583V4.36117C100.868 3.76812 101.104 3.19936 101.523 2.78C101.942 2.36065 102.511 2.12506 103.104 2.12506H176.896C177.489 2.12506 178.058 2.36065 178.477 2.78C178.896 3.19936 179.132 3.76812 179.132 4.36117V129.583C179.132 130.176 178.896 130.745 178.477 131.165C178.058 131.584 177.489 131.819 176.896 131.819Z",
    fill: "#E3D1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.909 109.986H113.091C112.518 109.986 111.968 109.759 111.563 109.353C111.158 108.948 110.931 108.399 110.931 107.826V18.2295C110.931 17.0355 111.899 16.0695 113.091 16.0695H166.909C168.104 16.0695 169.07 17.0355 169.07 18.2295V107.826C169.07 108.399 168.842 108.948 168.437 109.353C168.032 109.759 167.482 109.986 166.909 109.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.896 131.819H103.104C102.511 131.819 101.942 131.584 101.523 131.165C101.104 130.745 100.868 130.176 100.868 129.583V4.36117C100.868 3.76812 101.104 3.19936 101.523 2.78C101.942 2.36065 102.511 2.12506 103.104 2.12506H176.896C177.489 2.12506 178.058 2.36065 178.477 2.78C178.896 3.19936 179.132 3.76812 179.132 4.36117V129.583C179.132 130.176 178.896 130.745 178.477 131.165C178.058 131.584 177.489 131.819 176.896 131.819Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.909 109.986H113.091C112.518 109.986 111.968 109.759 111.563 109.353C111.158 108.948 110.931 108.399 110.931 107.826V18.2295C110.931 17.0355 111.899 16.0695 113.091 16.0695H166.909C168.104 16.0695 169.07 17.0355 169.07 18.2295V107.826C169.07 108.399 168.842 108.948 168.437 109.353C168.032 109.759 167.482 109.986 166.909 109.986Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.972 124.944C142.442 124.944 144.444 122.942 144.444 120.472C144.444 118.002 142.442 116 139.972 116C137.502 116 135.5 118.002 135.5 120.472C135.5 122.942 137.502 124.944 139.972 124.944Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.82 9.36111H151.181",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.338 32.8169C137.226 32.1794 133.561 33.8668 132.147 37.9782C131.957 38.5286 131.349 38.8242 130.787 38.6385C130.226 38.4528 129.925 37.856 130.114 37.3056C131.86 32.2324 136.553 29.8925 140.776 30.7578C145.089 31.6414 148.48 35.7345 147.989 42.5968C147.947 43.1763 147.435 43.6131 146.844 43.5724C146.253 43.5318 145.807 43.0291 145.849 42.4496C146.283 36.3759 143.36 33.4361 140.338 32.8169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.432 32.3756C137.082 31.6893 133.197 33.5165 131.711 37.834C131.603 38.1485 131.255 38.3175 130.934 38.2113C130.614 38.1052 130.442 37.7642 130.55 37.4497C132.224 32.5826 136.697 30.3825 140.682 31.199C144.719 32.0259 148.009 35.8719 147.53 42.5652C147.507 42.8963 147.214 43.1459 146.876 43.1227C146.538 43.0995 146.284 42.8122 146.307 42.4811C146.754 36.2384 143.73 33.0514 140.432 32.3756Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.276 32.0405C141.386 31.7264 141.734 31.5587 142.055 31.666L141.856 32.2348C142.055 31.666 142.055 31.6661 142.055 31.6663L142.056 31.6666L142.059 31.6674L142.065 31.6696C142.07 31.6713 142.076 31.6734 142.083 31.6761C142.098 31.6815 142.119 31.689 142.144 31.6986C142.193 31.7179 142.263 31.746 142.348 31.7842C142.519 31.8605 142.756 31.9772 143.036 32.144C143.596 32.4775 144.328 33.013 145.041 33.8283C146.478 35.4723 147.79 38.1996 147.531 42.5582C147.511 42.8896 147.221 43.1425 146.883 43.1232C146.545 43.1039 146.288 42.8196 146.307 42.4883C146.549 38.4216 145.329 36.0047 144.11 34.6107C143.495 33.9071 142.867 33.4502 142.399 33.1711C142.166 33.0316 141.972 32.9369 141.841 32.8784C141.775 32.8491 141.725 32.829 141.694 32.8169C141.678 32.8108 141.667 32.8068 141.661 32.8046C141.658 32.8036 141.657 32.803 141.656 32.8028C141.337 32.6946 141.167 32.3539 141.276 32.0405Z",
    fill: "#9F4AA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.882 42.6816H133.072C130.82 42.6816 128.996 44.471 128.996 46.6784V58.4183C128.996 60.6257 130.82 62.4152 133.072 62.4152H146.882C149.133 62.4152 150.958 60.6257 150.958 58.4183V46.6784C150.958 44.471 149.133 42.6816 146.882 42.6816Z",
    fill: "#9F4AA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.13 58.6317C133.173 56.7384 138.193 59.0143 140.5 52.5493C144.445 41.4996 148.318 44.1721 149.436 46.5972C150.755 49.4601 149.933 58.6317 149.933 58.6317C149.933 60.8354 149.13 62.4161 146.879 62.4161H133.071C130.821 62.4161 129.495 60.1492 131.13 58.6317Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.823 46.5838C128.823 46.5837 128.823 46.5836 129.027 46.5971C129.231 46.6106 129.231 46.6106 129.231 46.6107L129.229 46.6454C129.227 46.6685 129.225 46.703 129.222 46.748C129.216 46.838 129.208 46.9704 129.197 47.1397C129.177 47.4782 129.15 47.9641 129.121 48.5533C129.063 49.7318 129.001 51.3224 128.981 52.9724C128.962 54.6232 128.985 56.3293 129.098 57.7399C129.154 58.4456 129.233 59.0729 129.339 59.5805C129.446 60.095 129.576 60.4614 129.721 60.6652C129.933 60.9614 130.325 61.2249 130.883 61.4507C131.438 61.6749 132.133 61.8532 132.924 61.9927C134.505 62.2715 136.438 62.3902 138.319 62.4236C140.198 62.457 142.017 62.4052 143.366 62.3449C144.041 62.3148 144.598 62.2826 144.986 62.2579C145.18 62.2456 145.332 62.2352 145.436 62.2278C145.488 62.2242 145.527 62.2212 145.553 62.2193L145.583 62.217L145.591 62.2164L145.593 62.2163L145.593 62.2163C145.593 62.2162 145.593 62.2162 145.609 62.4159C145.625 62.6157 145.625 62.6157 145.625 62.6157L145.625 62.6157L145.615 62.6165C145.611 62.6168 145.606 62.6171 145.6 62.6176C145.596 62.618 145.59 62.6183 145.584 62.6188C145.558 62.6208 145.517 62.6237 145.465 62.6274C145.361 62.6349 145.208 62.6454 145.013 62.6578C144.622 62.6826 144.063 62.7149 143.385 62.7452C142.03 62.8057 140.202 62.8578 138.311 62.8242C136.423 62.7907 134.464 62.6714 132.852 62.387C132.045 62.2449 131.319 62.0603 130.727 61.8211C130.14 61.5834 129.664 61.2828 129.387 60.8952C129.19 60.6198 129.047 60.1837 128.938 59.6607C128.828 59.1306 128.747 58.4852 128.69 57.7713C128.576 56.343 128.553 54.6231 128.573 52.9677C128.593 51.3114 128.655 49.7156 128.713 48.5341C128.742 47.9433 128.769 47.4559 128.79 47.1161C128.8 46.9462 128.808 46.8132 128.814 46.7226C128.817 46.6773 128.819 46.6426 128.821 46.6193L128.823 46.5838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.837 50.5446C128.911 50.4606 129.04 50.451 129.125 50.523C129.914 51.1866 131.072 51.2093 132.215 51.185L135.817 51.1088C135.929 51.1064 136.023 51.1942 136.025 51.3048C136.028 51.4154 135.938 51.507 135.826 51.5094L132.224 51.5856C131.109 51.6093 129.785 51.6059 128.859 50.8271C128.774 50.755 128.764 50.6286 128.837 50.5446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.616 52.8916C128.689 52.8076 128.818 52.798 128.904 52.87C129.691 53.5326 130.85 53.5563 131.993 53.532L135.594 53.4558C135.707 53.4535 135.8 53.5412 135.803 53.6518C135.805 53.7624 135.716 53.854 135.603 53.8564L132.002 53.9325C132.002 53.9325 132.002 53.9326 132.002 53.9325C130.888 53.9563 129.562 53.9519 128.638 53.1741C128.552 53.1021 128.542 52.9756 128.616 52.8916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.616 55.8967C128.689 55.8128 128.818 55.8031 128.904 55.8751C129.691 56.5377 130.85 56.5615 131.993 56.5371L135.594 56.461C135.707 56.4586 135.8 56.5463 135.803 56.6569C135.805 56.7675 135.716 56.8592 135.603 56.8616L132.002 56.9377C130.888 56.9614 129.562 56.957 128.638 56.1792C128.552 56.1072 128.542 55.9807 128.616 55.8967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.719 42.8627H140.052V42.5105H147.756L147.774 42.5141C148.297 42.6204 148.973 42.9273 149.56 43.4282C150.149 43.9307 150.658 44.6365 150.824 45.5437C150.985 46.4195 151.066 48.1867 151.107 50.033C151.149 51.8853 151.15 53.835 151.15 55.0854H150.791C150.791 53.8349 150.789 51.8887 150.748 50.0408C150.707 48.1869 150.626 46.4493 150.471 45.6062C150.321 44.7944 149.866 44.1559 149.325 43.6939C148.788 43.2361 148.176 42.9595 147.719 42.8627Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.083 73.7188L125.09 69.2111L128.034 69.1071L127.977 73.692L132.023 72.3531L132.912 75.0593L128.81 76.3833L131.282 79.85L129.144 81.7358L126.464 78.1532L124.028 81.6121L121.684 80.0147L124.112 76.2524L120.002 75.1381L120.858 72.3641L125.083 73.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.091 73.7196L125.098 69.2111L128.043 69.1071L127.986 73.6928L132.032 72.3539L132.97 75.0713H128.043L126.799 71.9005L125.091 73.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.951 76.4883L121.579 80.1722L123.951 81.9375C125.265 79.1912 124.836 82.0413 123.951 76.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.083 73.7188L139.09 69.2111L142.034 69.1071L141.977 73.692L146.024 72.3531L146.912 75.0593L142.81 76.3833L145.283 79.85L143.144 81.7358L140.464 78.1532L138.028 81.6121L135.684 80.0147L138.112 76.2524L134.003 75.1381L134.858 72.3641L139.083 73.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 73.7196L139.098 69.2111L142.043 69.1071L141.986 73.6928L146.032 72.3539L146.97 75.0713H142.043L140.799 71.9005L139.091 73.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.951 76.4883L135.579 80.1722L137.951 81.9375C139.265 79.1912 138.836 82.0413 137.951 76.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.083 73.7188L153.09 69.2111L156.034 69.1071L155.977 73.692L160.024 72.3531L160.912 75.0593L156.81 76.3833L159.283 79.85L157.144 81.7358L154.464 78.1532L152.028 81.6121L149.684 80.0147L152.112 76.2524L148.003 75.1381L148.858 72.3641L153.083 73.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.091 73.7196L153.098 69.2111L156.043 69.1071L155.986 73.6928L160.032 72.3539L160.97 75.0713H156.043L154.799 71.9005L153.091 73.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.951 76.4883L149.579 80.1722L151.951 81.9375C153.265 79.1912 152.836 82.0413 151.951 76.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.083 88.7188L125.09 84.2111L128.034 84.1071L127.977 88.692L132.024 87.3531L132.912 90.0593L128.81 91.3832L131.283 94.8499L129.144 96.7358L126.464 93.1532L124.028 96.6121L121.684 95.0146L124.112 91.2524L120.003 90.1381L120.858 87.3641L125.083 88.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.091 88.7196L125.098 84.2111L128.043 84.1071L127.986 88.6928L132.032 87.3539L132.97 90.0713H128.043L126.799 86.9005L125.091 88.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.951 91.4883L121.579 95.1722L123.951 96.9375C125.265 94.1913 124.836 97.0413 123.951 91.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.083 88.7188L139.09 84.2111L142.034 84.1071L141.977 88.692L146.024 87.3531L146.912 90.0593L142.81 91.3832L145.283 94.8499L143.144 96.7358L140.464 93.1532L138.028 96.6121L135.684 95.0146L138.112 91.2524L134.003 90.1381L134.858 87.3641L139.083 88.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 88.7196L139.098 84.2111L142.043 84.1071L141.986 88.6928L146.032 87.3539L146.97 90.0713H142.043L140.799 86.9005L139.091 88.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.951 91.4883L135.579 95.1722L137.951 96.9375C139.265 94.1913 138.836 97.0413 137.951 91.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_6335_1761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.083 88.7188L153.09 84.2111L156.034 84.1071L155.977 88.692L160.023 87.3531L160.912 90.0593L156.81 91.3832L159.282 94.8499L157.144 96.7358L154.464 93.1532L152.028 96.6121L149.684 95.0146L152.112 91.2524L148.002 90.1381L148.858 87.3641L153.083 88.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.091 88.7196L153.098 84.2111L156.043 84.1071L155.986 88.6928L160.032 87.3539L160.97 90.0713H156.043L154.799 86.9005L153.091 88.7196Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.951 91.4883L149.579 95.1722L151.951 96.9375C153.265 94.1913 152.836 97.0413 151.951 91.4883Z",
    fill: "#913791"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 39.0092L147.129 57.142C146.827 57.672 146.265 58 145.66 58H143.5V57.9817H145.66C146.259 57.9817 146.814 57.6571 147.114 57.1328L147.121 57.1374L147.114 57.1328L157.484 39L157.5 39.0092Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.883 39L147.06 56.5464L142.124 47.4085C142.022 47.22 141.829 47.1026 141.617 47.1026L140.5 47.1088L145.806 57.322L143.414 57.6836L144.036 58.7188C144.141 58.8949 144.325 59 144.525 59H146.727C146.932 59 147.12 58.8857 147.224 58.7033L157.422 40.5513C157.526 40.3659 157.526 40.1341 157.419 39.9456L156.883 39Z",
    fill: "#008096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.569 47.9866L143.436 58H145.607C146.212 58 146.773 57.6734 147.076 57.1459L157.5 39H154.537C154.362 39 154.2 39.0942 154.11 39.2481L145.385 54.5711C145.198 54.9008 144.724 54.9008 144.534 54.5711L140.348 47.2393H137.99C137.613 47.2393 137.376 47.6569 137.569 47.9866Z",
    fill: "#09CA8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.477 39H157.408C157.441 39 157.471 39.0178 157.488 39.0467C157.504 39.0756 157.504 39.1111 157.488 39.14L147.18 57.1077C146.864 57.6588 146.278 58 145.647 58H143.5V57.8135H145.647C146.212 57.8135 146.737 57.5079 147.019 57.0144V57.0143L157.247 39.1865H154.477V39Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.542 47.0136C140.582 46.9858 140.634 47.002 140.658 47.0498L144.488 54.8495C144.512 54.8973 144.498 54.9586 144.458 54.9864C144.418 55.0142 144.366 54.998 144.342 54.9502L140.512 47.1505C140.488 47.1027 140.502 47.0414 140.542 47.0136Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 39.4173L201.873 36.3178L198.761 33.2181L195.651 36.3178L198.761 39.4173Z",
    fill: "#913791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8181 104.766L87.9526 102.64L85.8181 100.512L83.6833 102.64L85.8181 104.766Z",
    fill: "#913791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.868 112.102L82.0027 109.975L79.868 107.848L77.7334 109.975L79.868 112.102Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1109 100.376L81.2216 97.2769L78.1109 94.1772L75 97.2769L78.1109 100.376Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.302 30.8L195.713 27.4L192.302 24L188.889 27.4L192.302 30.8Z",
    fill: "#B468C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.225 29.0893L204.466 26.8571L202.225 24.6248L199.985 26.8571L202.225 29.0893Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 134,
    fill: "white",
    transform: "translate(75.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 33,
    fill: "white",
    transform: "translate(128.5 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(120 69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(134 69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(148 69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(120 84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(134 84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_6335_1761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(148 84)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfaAppSmartphone);
export default __webpack_public_path__ + "static/media/mfa_app_smartphone.7a88464fa4a9be8d328308af472c2ecb.svg";
export { ForwardRef as ReactComponent };